module.exports = __webpack_public_path__ + "static/media/1009910.0d9166d8.jpg";